export const variables = {
  // API_URL: "http://localhost:5000/api/",
  // PHOTO_URL: "http://localhost:5000/Upload/",
  API_URL: "https://api.homedepotoflebanon.com/api/",
  PHOTO_URL: "https://api.homedepotoflebanon.com/Upload/",
  };


  // API_URL:"https://api.homedepotoflebanon.com/api/",
  // PHOTO_URL:"https://api.homedepotoflebanon.com/upload/",

 